import { handleCssUnit } from '../../model/CssUnit'

export const spacing = handleCssUnit
